import i18n, { InitOptions } from 'i18next';
import XHR from 'i18next-xhr-backend';
/* eslint-disable-next-line custom-rules/no-react-i18next */
import { initReactI18next } from 'react-i18next';
import { renderUnresolvedPlaceholder } from './interpolation';

// this is injected by webpack. This is only defined in angular project right now.
declare const LOCALE_HASH: string;

export function initI18n(options?: Partial<InitOptions>) {
  i18n
    .use(XHR)
    .use(initReactI18next)
    .init({
      backend: {
        loadPath: `locales${
          typeof LOCALE_HASH !== 'undefined' ? `/${LOCALE_HASH}` : ''
        }/{{ns}}/{{lng}}.json`
      },
      defaultNS: 'module',
      fallbackLng: 'en-us',
      fallbackNS: ['core', 'ui'],
      interpolation: {
        escapeValue: false,
        skipOnVariables: true
      },
      keySeparator: '::',
      lng: 'en-us',
      load: 'currentOnly',
      lowerCaseLng: true,
      missingInterpolationHandler: renderUnresolvedPlaceholder,
      ns: ['core', 'ui', 'module'],
      nsSeparator: ':::',
      react: {
        useSuspense: false
      },
      ...(options || {})
    });
}
